namespace GeniuzPOS.Purchase {
    export class ListAppPurRequestColumns {
        static columnsKey = 'Purchase.ListAppPurRequest';
    }
}
